import { Controller } from "@hotwired/stimulus";

export default class ReadRoomsController extends Controller {
  static targets = ["chatArea"];

  chatAreaTargetConnected(element) {
    this.read();
  }

  read() {
    setTimeout(() => {
      const roomId = Current?.room?.id;
      if (!roomId) return;
      const ele = $(".chat-list")[0];
      const controller = this.application.getControllerForElementAndIdentifier(ele, "room-list");
      controller?.read(roomId);
    }, 500);
  }

  backToList(event) {
    const userList = document.getElementById("user-list");
    const chatArea = document.getElementById("chat-area");
    const headerBackBtn = document.getElementById("header-back-btn");
    if (globalThis.innerWidth < 1399) {
      const navigation = this.application.getControllerForElementAndIdentifier(
        document.body,
        "navigation-history"
      );
      if (navigation) navigation.back(event);

      setTimeout(() => {
        userList.classList.remove("d-none");
        chatArea.classList.add("d-none");
        headerBackBtn.classList.remove("d-none");
        $(".room-user").removeClass("disabled-link active");
      }, 100);
    }
  }
}
